<h1 mat-dialog-title>Box Weight</h1>
<div mat-dialog-content  class="custom-dialog">
    <app-weighing-scale-input (weight)="updateWeight($event)">Box kilogram</app-weighing-scale-input>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-button [mat-dialog-close]="weight" cdkFocusInitial>Ok</button>
</div>
